export const FirebaseConfig = {
	"projectId": "bookingcarz",
	"appId": "1:797801711145:web:a548942057817dc374be38",
	"databaseURL": "https://bookingcarz-default-rtdb.firebaseio.com",
	"storageBucket": "bookingcarz.appspot.com",
	"locationId": "europe-west",
	"apiKey": "AIzaSyCafIwT3IN4ekzrsafOVcoWnNp537Jma9I",
	"authDomain": "bookingcarz.firebaseapp.com",
	"messagingSenderId": "797801711145",
	"measurementId": "G-11QK7FTWV5"
};
 